// extracted by mini-css-extract-plugin
export default {"headerCover":"style_headerCover__z5GEG","headerInfo":"style_headerInfo__CszVH","userAvatar":"style_userAvatar__JuWXL","userName":"style_userName__Ypmpt"};